import React, { useState } from "react";
import {
    Input
} from './input-box-styles';

export default function Dropdown(props) {
    return (
        <Input {...props} />
    );
}